const MAX_EVENT_NAME_LENGTH = 40;
const MAX_PARAMETER_NAME_LENGTH = 40;
const MAX_STRING_VALUE_LENGTH = 100;

function normaliseName(value, fallback) {
	const name = String(value || '')
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9_]/g, '_')
		.replace(/_+/g, '_')
		.replace(/^_+|_+$/g, '')
		.slice(0, MAX_EVENT_NAME_LENGTH);
	return /^[a-z]/.test(name) ? name : fallback;
}

function normaliseValue(value) {
	if (typeof value === 'boolean' || typeof value === 'number') return value;
	if (typeof value === 'string') return value.trim().slice(0, MAX_STRING_VALUE_LENGTH);
	return null;
}

export function trackAnalyticsEvent(eventName, parameters = {}) {
	if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;

	const name = normaliseName(eventName, 'app_interaction');
	const safeParameters = {};
	for (const [key, value] of Object.entries(parameters || {})) {
		const parameterName = normaliseName(key, '').slice(0, MAX_PARAMETER_NAME_LENGTH);
		const parameterValue = normaliseValue(value);
		if (parameterName && parameterValue !== null && parameterValue !== '') {
			safeParameters[parameterName] = parameterValue;
		}
	}

	safeParameters.page_path = `${window.location.pathname}${window.location.search}`.slice(0, 100);
	window.gtag('event', name, safeParameters);
	return true;
}
